/* Imports needed for all question form subclasses. */
import * as React from 'react';
import {
    QuestionFormBase,
    QuestionFormBaseProps,
    QuestionFormBaseState,
    mapStateToQuestionFormBaseProps,
    mapDispatchToQuestionFormBaseProps
} from '../../QuestionFormBase';
import classnames from 'classnames';
import * as _ from 'lodash';
import { connect } from 'react-redux';
import { MULTIMEDIA_TYPES, QTYPES } from '@nexxt/common/types';
import { QUOTA_STATUS } from '@nexxt/common/types';
import NotifyHOC from '../../../../../../HOC/Notifications';

/* Components used in this question form. */
import BuilderHeader from '../../../common/builderHeader';
import QuestionSettings from '../../../common/questionSettings';
import InputRadio from '../../../common/radioButton/inputRadio';
import MultimediaBubble from '../../../common/MultimediaBubble';

type Props = QuestionFormBaseProps;

type States = QuestionFormBaseState;

class DepartingMessage extends QuestionFormBase<Props, States> {
    constructor(p: QuestionFormBaseProps) {
        super(p, QTYPES.DEPARTING_MESSAGE);
    }

    render() {
        const { currentProject } = this.props;
        const { question, isSettingBoxLayoutOpen } = this.state;
        const questionError =
            (this.state.showError && this.state.questionError) || {};

        return (
            <React.Fragment>
                <div>
                    <div className="project-add--question-builder">
                        <BuilderHeader
                            toggleSettingBoxLayout={this.toggleSettingBoxLayout}
                            isSettingBoxLayoutOpen={isSettingBoxLayoutOpen}
                            showAlert={!this.props.editEnabled}
                            alertMessages={this.getWarningMessage()}
                            question={question}
                            setValue={this.setQuestion}
                            disabled={!this.props.editEnabled}
                            errorObject={this.state.questionError}
                        />
                        <div className="builder-body">
                            {(isSettingBoxLayoutOpen && (
                                <QuestionSettings
                                    onClose={this.toggleSettingBoxLayout}
                                    question={question}
                                    questionSettings={{
                                        showContinueButton: true,
                                        showNotApplicableOption: true
                                    }}
                                    setValue={this.setQuestion}
                                    disabled={!this.props.editEnabled}
                                />
                            )) ||
                                null}
                            {this.renderErrorNotes()}
                            <MultimediaBubble
                                question={question}
                                languages={currentProject.languages}
                                setValue={this.setQuestion}
                                setValueWithLanguage={
                                    this.NEW_setQuestionTextTranslation
                                }
                                addNewBubble={this.NEW_addNewEditor}
                                removeBubble={this.NEW_removeEditor}
                                disabled={!this.props.editEnabled}
                                questionError={questionError}
                                settings={{ showClose: true }}
                            />
                            {/** CONTINUE BUTTON */}
                            {(question.showContinueButton && (
                                <MultimediaBubble
                                    languages={currentProject.languages}
                                    question={question}
                                    setValue={this.setQuestion}
                                    setValueWithLanguage={
                                        this.NEW_setQuestionTextTranslation
                                    }
                                    questionError={questionError}
                                    keyName="continueTexts"
                                    defaultText="BUTTON.CONTINUE"
                                    disabled={!this.props.editEnabled}
                                    disableAddBubble
                                    defaultTextType={MULTIMEDIA_TYPES.TEXT}
                                    questionText="Continue button text"
                                    settings={{
                                        noBorder: true,
                                        useTranslation: true
                                    }}
                                />
                            )) ||
                                null}
                            {(question.showNotApplicableOption && (
                                <MultimediaBubble
                                    languages={currentProject.languages}
                                    question={question}
                                    setValue={this.setQuestion}
                                    setValueWithLanguage={
                                        this.NEW_setQuestionTextTranslation
                                    }
                                    questionError={questionError}
                                    keyName="notApplicableTexts"
                                    disabled={!this.props.editEnabled}
                                    disableAddBubble
                                    defaultTextType={MULTIMEDIA_TYPES.TEXT}
                                    questionText="Not Applicable text"
                                    defaultText="BUTTON.NOT_APPLICABLE"
                                    settings={{
                                        noBorder: true,
                                        useTranslation: true
                                    }}
                                />
                            )) ||
                                null}

                            <div className="row">
                                <div
                                    className={classnames(
                                        'col-md-12 form-group',
                                        {
                                            error:
                                                questionError &&
                                                questionError.completed
                                        }
                                    )}
                                >
                                    <label className="form-group__label form-group__label--block">
                                        User&apos;s survey progress:
                                    </label>
                                    <InputRadio
                                        options={[
                                            {
                                                label: 'Completed',
                                                value: QUOTA_STATUS.COMPLETE
                                            },
                                            {
                                                label: 'Terminate',
                                                value: QUOTA_STATUS.TERMINATE
                                            },
                                            {
                                                label: 'Quota Full',
                                                value: QUOTA_STATUS.QUOTA_FULL
                                            }
                                        ]}
                                        name="completed"
                                        selectedValue={question.completed}
                                        setValue={(value) =>
                                            this.setQuestion('completed', value)
                                        }
                                        disabled={!this.props.editEnabled}
                                    />
                                    {questionError &&
                                    questionError.completed ? (
                                        <span className="form-group__error-msg">
                                            {questionError.completed}
                                        </span>
                                    ) : null}
                                </div>
                            </div>
                            <div className="row">
                                <div
                                    className={classnames(
                                        'col-md-12 form-group',
                                        {
                                            error:
                                                questionError &&
                                                questionError.completed
                                        }
                                    )}
                                >
                                    <label className="form-group__label form-group__label--block">
                                        Redriect URL
                                    </label>
                                    <input
                                        type="text"
                                        className="form-group__control"
                                        // placeholder="Continue"
                                        onChange={(e) => {
                                            this.setQuestion(
                                                'url',
                                                e.target.value
                                            );
                                        }}
                                        value={question.url}
                                        placeholder={'https://nexxt.in'}
                                        disabled={!this.props.editEnabled}
                                    />
                                    {questionError && questionError.url ? (
                                        <span className="form-group__error-msg">
                                            {questionError.url}
                                        </span>
                                    ) : null}
                                </div>
                            </div>
                        </div>
                        {/*end of builder body*/}
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default NotifyHOC(
    connect(
        mapStateToQuestionFormBaseProps,
        mapDispatchToQuestionFormBaseProps
    )(DepartingMessage)
);
